import React from "react";
import { IMAGES, PAPERBACK_URL, KINDLE_URL } from "../site-data";
import { ArrowUpRight, Lock, BookMarked } from "lucide-react";

const WORKS = [
  {
    key: "8-roses",
    title: "A Bouquet of 8 Roses",
    subtitle: "Stories that touch every heart",
    year: "2026",
    status: "Available now",
    cover: IMAGES.bookFront,
    href: PAPERBACK_URL,
    kindleHref: KINDLE_URL,
    primary: true,
  },
  {
    key: "coming-soon-1",
    title: "Untitled — Book Two",
    subtitle: "A new collection in the works",
    year: "Coming soon",
    status: "In progress",
    cover: null,
    href: null,
    kindleHref: null,
    primary: false,
  },
];

export default function Works() {
  return (
    <section
      id="works"
      data-testid="works-section"
      className="py-24 lg:py-36 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 border-b border-[#e5dcd0] pb-8">
          <div>
            <p className="eyebrow mb-4">Works</p>
            <h2
              className="font-serif text-4xl lg:text-5xl tracking-tight text-[#1c1a1a]"
              data-testid="works-title"
            >
              The shelf, growing.
            </h2>
          </div>
          <p className="font-serif italic text-[#4a4646] text-xl max-w-sm">
            A small shelf today, with many more stories waiting to be told.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {WORKS.map((w) => (
            <article
              key={w.key}
              data-testid={`work-card-${w.key}`}
              className="group relative"
            >
              <div className="aspect-[3/4] bg-[#f0eae1] overflow-hidden border border-[#e5dcd0] flex items-center justify-center">
                {w.cover ? (
                  <img
                    src={w.cover}
                    alt={w.title}
                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                  />
                ) : (
                  <div className="flex flex-col items-center gap-4 text-[#8b2e3e]/70 px-10 text-center">
                    <Lock size={28} strokeWidth={1.25} />
                    <p className="font-serif italic text-lg">
                      The next bouquet is being arranged.
                    </p>
                  </div>
                )}
              </div>

              <div className="mt-5 flex items-start justify-between gap-4">
                <div>
                  <p className="eyebrow !text-[#4a4646] mb-2">{w.year}</p>
                  <h3 className="font-serif text-2xl text-[#1c1a1a] leading-tight">
                    {w.title}
                  </h3>
                  <p className="mt-1 text-[#4a4646]">{w.subtitle}</p>
                </div>
                {w.href ? (
                  <div className="flex items-center gap-2 mt-1">
                    {w.kindleHref && (
                      <a
                        href={w.kindleHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`work-kindle-${w.key}`}
                        aria-label={`Read ${w.title} on Kindle`}
                        title="Read on Kindle"
                        className="p-2 border border-[#e5dcd0] text-[#4a4646] hover:bg-[#1c1a1a] hover:text-white hover:border-[#1c1a1a] transition-colors"
                      >
                        <BookMarked size={16} />
                      </a>
                    )}
                    <a
                      href={w.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`work-link-${w.key}`}
                      aria-label={`Buy ${w.title}`}
                      title="Paperback on Amazon"
                      className="p-2 border border-[#1c1a1a] text-[#1c1a1a] hover:bg-[#8b2e3e] hover:text-white hover:border-[#8b2e3e] transition-colors"
                    >
                      <ArrowUpRight size={18} />
                    </a>
                  </div>
                ) : (
                  <span className="mt-1 eyebrow !text-[#8b2e3e]">{w.status}</span>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
